import { watch } from 'vue';
import {
    useState, useActions,
} from 'vuex-composition-helpers';
import { IMapForFiltersSerpActions, IMapForFiltersSerpState } from '@ve/components/searchFilters/store/types';
import { nameFilterSerpStore } from '@ve/components/searchFilters/store/getFiltersSerpStore';
import useFilterHotelsModel from './useFilterHotelsModel';

export default function () {
    const {
        childServiceFilter,
        setChildServiceFilter,
        setRestTypeFilter,
        restTypeFilter,
        setBeachTypeFilter,
        setRenovations,
        beachTypeFilter,
        renovationFilter,
    } = useFilterHotelsModel();
    const {
        childServiceFilterIds: takenServiceChildBackbone,
        restType: restTypeFilterIdBackbone,
        takenBeachType: takenBeachTypeBacbkone,
        renovations: renovationsBackbone,
    } = useState<IMapForFiltersSerpState>(nameFilterSerpStore, ['childServiceFilterIds', 'restType', 'takenBeachType', 'renovations']);
    const {
        action_childServiceFilterIds: setServiceChildBackbone,
        action_restType: setRestTypeFilterBackbone,
        action_takenBeachType: action_takenBeachTypeBacbkone,
        action_renovations,
    } = useActions<IMapForFiltersSerpActions>(nameFilterSerpStore, ['action_childServiceFilterIds', 'action_restType', 'action_takenBeachType', 'action_renovations']);

    watch(childServiceFilter, (value) => {
        setServiceChildBackbone(value);
    });
    watch(takenServiceChildBackbone, (value) => {
        setChildServiceFilter(value);
    }, { immediate: true });

    watch(restTypeFilter, (value) => {
        setRestTypeFilterBackbone(value);
    });

    watch(restTypeFilterIdBackbone, (value) => {
        setRestTypeFilter(value || 0);
    }, { immediate: true });

    watch(takenBeachTypeBacbkone, (value) => {
        setBeachTypeFilter(value);
    }, { immediate: true });

    watch(renovationsBackbone, (value) => {
        setRenovations(value);
    }, { immediate: true });

    watch(renovationFilter, (value) => {
        action_renovations(value);
    }, { immediate: true })

    watch(beachTypeFilter, (value) => {
        action_takenBeachTypeBacbkone(value);
    });
}